'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var material = require('@mui/material');

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const RecaptchaPolicy = (props)=>{
    return /*#__PURE__*/ jsxRuntime.jsx(material.Typography, _extends({}, props, {
        dangerouslySetInnerHTML: {
            __html: `This site is protected by reCAPTCHA and the Google
      <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">Privacy Policy</a> and
      <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer">Terms of service</a>
      apply.`
        }
    }));
};

module.exports = RecaptchaPolicy;
